import Layout from '@@client/app/Layout'
import BrandPage from '@@client/parts/make/BrandPage'
import {getServerConfig} from '@@client/config'
import {getVehicleBrandsPageContent} from '@@client/content/api'
import Markdown from '@@client/components/Markdown'

export default function Page({title, lead, failed}) {
    if(failed) return null

    return (
        <Layout title={title}>
            <BrandPage>
                <h1>{title}</h1>
                <Markdown>{lead || ''}</Markdown>
            </BrandPage>
        </Layout>
    )
}

export async function getServerSideProps() {
    const config = getServerConfig()

    const result = await getVehicleBrandsPageContent(config.content.apiUrl)

    return {
        props: result.success ? result.entity : {failed: true},
    }
}
